import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminNewsCategories = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.GET_ALL, { params });
    return response.data;
};
export const getAdminNewsCategoryById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.GET_BY_ID(id));
    return response.data;
};
export const createNewsCategory = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.CREATE, data);
    return response.data;
};
export const updateNewsCategory = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.UPDATE(id), data);
    return response.data;
};
export const deleteNewsCategory = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.DELETE(id));
    return response.data;
};

